import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '@/utils/apiservice';
import RegistrationFailPageView from './registrationfailpage.view';

const RegistrationFailPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const registrationId = searchParams.get('id') || searchParams.get('Details2');

  const [retryLink, setRetryLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  useEffect(() => {
    if (registrationId) {
      generateRetryLink();
    }
  }, [registrationId]);

  const generateRetryLink = async () => {
    try {
      setLoading(true);
      setError('');
      const res = await api.post(`/api/registrations/${encodeURIComponent(registrationId!)}/generate-retry`);
      setRetryLink(res.data.retryLink);
      setEmailSent(true);
    } catch (err: any) {
      const msg = err.response?.data?.message || 'Could not generate retry link.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <RegistrationFailPageView
      loading={loading}
      error={error}
      retryLink={retryLink}
      emailSent={emailSent}
      onNavigateHome={() => navigate('/')}
    />
  );
};

export default RegistrationFailPage;
